import { Box, Card, CardContent, Typography } from '@mui/material';
import React from 'react';
import { LicenseMetricsData } from '../../api/apis/OrgPricebookLicenseMetricsApi';
import { Svgs } from '../../assets/svg';
import PricebookRowLabel from '../../components/PricebookRowLabel';
import { PricebookBundle } from '../../models/PricebookData';
import { getActivePrice } from '../../helpers/pricebookUtils';

interface MemberPaysMetricsCardProps {
  licenseMetric: LicenseMetricsData;
  pricebookBundle?: PricebookBundle;
}

const MemberPaysMetricsCard: React.FC<MemberPaysMetricsCardProps> = ({
  licenseMetric,
  pricebookBundle,
}) => {
  const selectedPrice = pricebookBundle?.prices
    ? getActivePrice(pricebookBundle.prices, { preferOneTime: true })
    : undefined;

  return (
    <Card variant='ghost' color='secondary' className='pricebook-metric-card'>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
            <img
              src={licenseMetric.artUrl}
              alt='Package Logo'
              style={{ width: '30px', height: '30px', objectFit: 'contain', flexShrink: 0 }}
            />
            <PricebookRowLabel
              name={licenseMetric.pricebookName}
              price={selectedPrice}
              shortDescription={pricebookBundle?.pricebook.internalAdminDescription}
              metadata={pricebookBundle?.pricebook.metadata}
              truncate
            />
          </Box>
          <Box sx={{ flex: '1 1 0', minWidth: '16px' }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px', flexShrink: 0 }}>
            <Typography variant='p16SemiBold' color='secondary' noWrap>
              Active users
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Svgs.IconMembersDefault />
              <Typography
                variant='p20SemiBold'
                color='secondary'
                sx={{ minWidth: '4ch', textAlign: 'left' }}>
                {licenseMetric.activeLicenses}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MemberPaysMetricsCard;
